import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getAwscChatMessageRequest = (query, params) =>
  restRequest({
    uri: 'awscChatMessage',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const createAwscChatMessage = (body, params) =>
  restRequest({
    uri: 'awscChatMessage',
    body,
    method: HttpMethods.Post,
    ...params,
  });

export const updateAwscChatMessage = (id, body, params) =>
  restRequest({
    uri: `awscChatMessage/${id}`,
    method: HttpMethods.Patch,
    body,
    ...params,
  });

export const deleteAwscChatMessage = (id, params) =>
  restRequest({
    uri: `awscChatMessage/${id}`,
    method: HttpMethods.Delete,
    ...params,
  });
